module.exports = __webpack_public_path__ + "img/hacienda-resort-1.d8f610fd.jpg";